import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/** Lands on "/" → redirects based on role. */
export default function RoleHome() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink">
        <div className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}
